import Vue from 'vue'
import Card from "./card";
import UiButton from "./ui-button";
import MdiIcon from "./mdi-icon";

Vue.component('pan-card', Card);
Vue.component('ui-button', UiButton);
Vue.component('icon', MdiIcon);